/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   export class DvpgManageWizardFlags {

      public isPolicyTypePageInitialized: boolean;
   }
}
